module.exports = __webpack_public_path__ + "static/media/brands-05-masa@2x.3cad785f.png";